import { render } from "./SecondaryInsurance.vue?vue&type=template&id=3101782f"
import script from "./SecondaryInsurance.vue?vue&type=script&lang=js"
export * from "./SecondaryInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/billingInfo/forms/SecondaryInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3101782f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3101782f', __exports__)) {
    console.log('reload')
    api.reload('3101782f', __exports__)
  }
  
  module.hot.accept("./SecondaryInsurance.vue?vue&type=template&id=3101782f", () => {
    console.log('re-render')
    api.rerender('3101782f', render)
  })

}


export default __exports__